import React from "react";
import DateRangePk from "../Misc/DateRangePk";
import TimePeriodLabel from "../Misc/TimePeriodLabel";
import TimePeriodPicker from "../Misc/TimePeriodPicker";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default class EssenceReferenceCalendarEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      workdays: new Array(7).fill(false),
      holidays: [],
      schedule: [],
      holidayAddShow: false,
      holidayAddStart: null,
      holidayAddEnd: null,

      timePickerShowDay: false,
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = () => {
    const editData = this.props.data;

    const dayoff = editData.dayoff || [];
    let workdays = new Array(7).fill(true);

    dayoff.forEach((day) => {
      workdays[day - 1] = false;
    });

    const holidays = editData.holiday || [];

    let schedule = [];
    (editData.schedule || []).forEach(([scheduleIndex, from, to]) => {
      if (!Array.isArray(schedule[scheduleIndex])) {
        schedule[scheduleIndex] = [];
      }
      schedule[scheduleIndex].push([from, to]);
    });

    this.setState(
      {
        editData,
        workdays,
        holidays,
        schedule,
      },
      () => this.triggerChange()
    );
  };

  holidayAddShow = () => {
    this.setState({
      holidayAddShow: true,
      holidayAddStart: null,
      holidayAddEnd: null,
    });
  };

  holidayAddChange = (holidayAddStart, holidayAddEnd) => {
    this.setState({ holidayAddStart, holidayAddEnd });
  };

  holidayAddHide = () => {
    this.setState({ holidayAddShow: false });
    let { holidayAddStart, holidayAddEnd } = this.state;
    if (holidayAddStart && holidayAddEnd) {
      if (holidayAddEnd === holidayAddStart) {
        holidayAddEnd = new Date(holidayAddStart);
      }

      let addList = [];
      for (
        let dt = holidayAddStart;
        dt <= holidayAddEnd;
        dt.setDate(dt.getDate() + 1)
      ) {
        addList.push([dt.getMonth() + 1, dt.getDate()]);
      }
      let holidays = addList.concat(this.state.holidays);
      this.setState({ holidays }, () => this.triggerChange());
    }
  };

  holidayRemove = (index) => {
    this.setState(
      (state) => {
        let holidays = state.holidays;
        holidays.splice(index, 1);
        return { holidays };
      },
      () => this.triggerChange()
    );
  };

  toggleWorkday = (index) => {
    this.setState(
      (state) => {
        let workdays = state.workdays;
        workdays[index] = workdays[index] ? false : true;
        return { workdays };
      },
      () => this.triggerChange()
    );
  };

  scheduleAdd = (period = []) => {
    this.setState(
      ({ schedule, timePickerShowDay }) => {
        if (Array.isArray(schedule[timePickerShowDay])) {
          schedule[timePickerShowDay].push(period);
        } else {
          schedule[timePickerShowDay] = [period];
        }

        return { schedule, timePickerShowDay: false };
      },
      () => this.triggerChange()
    );
  };

  scheduleRemove = (scheduleIndex, periodIndex) => {
    this.setState(
      (state) => {
        let schedule = state.schedule || [];
        if (Array.isArray(schedule[scheduleIndex])) {
          schedule[scheduleIndex].splice(periodIndex, 1);
        }

        return { schedule };
      },
      () => this.triggerChange()
    );
  };

  scheduleCange = (scheduleIndex, periodIndex, period) => {
    this.setState(
      (state) => {
        let schedule = state.schedule || [];
        if (Array.isArray(schedule[scheduleIndex])) {
          schedule[scheduleIndex][periodIndex] = period;
        }

        return { schedule };
      },
      () => this.triggerChange()
    );
  };

  scheduleDragEnd = ({ e, scheduleIndex }) => {
    const { draggableId, destination, source } = e;
    if (!e.destination || !draggableId || !scheduleIndex) {
      return;
    }

    this.setState(
      ({ schedule }) => {
        if (Array.isArray(schedule[scheduleIndex])) {
          let sourceItem = schedule[scheduleIndex][source.index];
          schedule[scheduleIndex][source.index] = [
            ...schedule[scheduleIndex][destination.index],
          ];
          schedule[scheduleIndex][destination.index] = [...sourceItem];

          return { schedule };
        }
      },
      () => this.triggerChange()
    );
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      let dayoff = [];
      let week = 0;
      this.state.workdays.forEach((day, index) => {
        if (day) {
          week++;
        } else {
          dayoff.push(index + 1);
        }
      });

      let schedule = [];
      (this.state.schedule || []).forEach((periods, scheduleIndex) => {
        if (Array.isArray(periods)) {
          periods.forEach((period) => {
            schedule.push([scheduleIndex, ...period]);
          });
        }
      });

      let changeData = {
        holiday: this.state.holidays,
        workstart: this.state.editData.workstart || null,
        workcount: this.state.editData.workcount || null,
        reststart: this.state.editData.reststart || null,
        restcount: this.state.editData.restcount || null,
        week,
        dayoff,
        schedule,
      };
      this.props.onChange(changeData);
    }
  };

  render() {
    const { timePickerShowDay } = this.state;

    const editData = this.state.editData || {};
    const holidays = this.state.holidays || [];
    const allDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
    const curDate = new Date();
    return (
      <>
        {timePickerShowDay && (
          <TimePeriodPicker
            title="Добавление периода"
            onChange={this.scheduleAdd}
            onClose={() => this.setState({ timePickerShowDay: false })}
          />
        )}
        <hr />
        <div className="form-group">
          <div className="row">
            <div className="col-lg-12">
              <label className="mb-4">Расписание:</label>
              <div className="row">
                {allDays.map((day, index) => {
                  let scheduleIndex = index + 1;
                  let schedule = this.state.schedule[scheduleIndex] || [];

                  return (
                    <div className="col-lg border-right" key={day}>
                      <div className="mb-4 d-flex align-items-center justify-content-between">
                        <label className="checkbox">
                          <input
                            onChange={() => this.toggleWorkday(index)}
                            checked={this.state.workdays[index]}
                            type="checkbox"
                          />
                          <span className="mr-2"></span>
                          {day}
                        </label>
                        <i
                          onClick={() =>
                            this.setState({ timePickerShowDay: scheduleIndex })
                          }
                          title="Добавить"
                          className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                        ></i>
                      </div>
                      <DragDropContext
                        onDragEnd={(e) =>
                          this.scheduleDragEnd({ e, scheduleIndex })
                        }
                      >
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {schedule.map((period = [], idx) => (
                                <Draggable
                                  key={idx}
                                  draggableId={String(idx)}
                                  index={idx}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <TimePeriodLabel
                                        from={period[0]}
                                        to={period[1]}
                                        onRemove={() =>
                                          this.scheduleRemove(
                                            scheduleIndex,
                                            idx
                                          )
                                        }
                                        onChange={(period) =>
                                          this.scheduleCange(
                                            scheduleIndex,
                                            idx,
                                            period
                                          )
                                        }
                                        key={idx}
                                        className="mb-2"
                                      />
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-lg-12">
              <label>
                Праздничные дни:
                <i
                  title="Добавить дату"
                  onClick={() => this.holidayAddShow()}
                  className="fa text-muted cursor-pointer text-hover-primary ml-2 fa-calendar-plus-o"
                ></i>
              </label>
              <DateRangePk
                closeFn={() => this.holidayAddHide()}
                changeFn={(startDate, endDate) =>
                  this.holidayAddChange(startDate, endDate)
                }
                show={this.state.holidayAddShow}
              />

              {holidays.length ? (
                <div className="form-control h-auto">
                  {holidays.map(([month, day], index) => {
                    let date = new Date(curDate.getFullYear(), month - 1, day);
                    return (
                      <span
                        className="label text-capitalize mb-2 mr-1 label-pill label-inline"
                        key={index}
                      >
                        {`${date.toLocaleString("ru", {
                          month: "long",
                        })} ${date.toLocaleString("ru", { day: "2-digit" })}`}

                        <i
                          title="Убрать дату"
                          onClick={() => this.holidayRemove(index)}
                          className="fa text-muted cursor-pointer text-hover-danger ml-2 fa-close"
                        ></i>
                      </span>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}
